import React, { useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { Controller, useForm } from 'react-hook-form'
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask'
const cardnumbermask = createDefaultMaskGenerator('9999')
const expirymask = createDefaultMaskGenerator('99/99')
// import 'react-toastify/dist/ReactToastify.css'
import { downloadTicket, getTicketDetails } from '../../redux/actions/userDetails'
import 'react-datepicker/dist/react-datepicker.css'
import { Circles } from 'react-loader-spinner'
import Ticket from '../main'
import NoData from '../../components/NoData'
import { errorMessage } from '../../constants/errorMessage'
import { addEventLog } from '../../redux/actions/EventsLog'
import CONSTANTS from '../../redux/constants'
// import logos from '../../assets/img/logos.svg'

function SearchTicket(props) {
	const { handleSubmit, control } = useForm()
	const { dispatch, loader, loaderDownload, notify } = props
	const [cardNumber, setCardNumber] = useState('')
	const [cardExpiry, setCardExpiry] = useState('')
	const [ticketDetails, setTicketDetails] = useState('')
	const [error, setError] = useState('')
	

	const onSubmit = () => {

		// const payload = { ...data, checkin_date: data?.checkin_date ? moment(data?.checkin_date).format('Y-MM-DD') : '', card_number: cardNumber, card_expry: cardExpiry }
		// const isEmpty = Object.values(payload).every(x => x === null || x === '')
		const payload = {
			'ticket': '',
			'phone': '',
			'cardLast4': cardNumber,
			'cardExpiry': cardExpiry,
			'license_plate': ''
		}
		if (cardNumber != '' && cardExpiry != '') {
			dispatch(getTicketDetails(payload)).then((res) => {
				if (res?.status === 201 || res?.status === 200) {
					if (res?.data && res?.data != null) {
						// notify('success', 'T successfully')
						setTicketDetails(res?.data)
					} else {
						setError(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
						notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
						let errObject = { 
							payload: payload,
							error: res,
							errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
						}
						dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getTicketDetails-SearchTicket.js-41`))
					}
				} else {
					setTicketDetails('')
					setError(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
					notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
					let errObject = { 
						payload: payload,
						error: res,
						errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
					}
					dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getTicketDetails-SearchTicket.js-41`))
				}
			}).catch((err) => {
				setTicketDetails('')
				setError(errorMessage?.somethingWentWrong)
				notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
				let errObject = { 
					payload: payload,
					error: err,
					errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
				}
				dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getTicketDetails-SearchTicket.js-41`))
			})
		} else {
			notify('error', 'Please fill the card details')
		}
	}

	const handleCardNumber = (event) => {
		setCardNumber(event)
	}

	const handleCardExpiry = (event) => {
		setCardExpiry(event)
	}

    const handleDownloadTicket = (ticketId) => {
        dispatch(downloadTicket(ticketId)).then(() => {
            notify('Success', 'E-Ticket Downloaded')
        }).catch((err) => {
            notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
			let errObject = { 
				payload: ticketId,
				error: err,
				errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
			}
			dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} downloadTicket-SearchTicket.js-79`))
        })
    }

	return (
		<div>
            <div className="card bg-white rounded border-0">
				
				<div className="card-body">
					<form onSubmit={handleSubmit(onSubmit)}>
						<div className="row mb-3">
									<div className="col col-sm-12 col-12">
										<div className="form-group"><label htmlFor="card_number">Card Information</label></div>
										<div className="input-group form-group">
											<Controller
												name="card_number"
												type="text"
												id="card_number"
												control={control}
												rules={{ required: (cardExpiry.length === 4 && cardNumber.length !== 4) ? true : false, maxLength: 4 }}
												render={({ field }) => <MaskedInput
													maskGenerator={cardnumbermask}
													autoComplete="off"
													pattern="[0-9 ]{4}"
													maxLength='4'
													{...field}
													title="Card no. should be 15-16 digit numberic"
													className="form-control"
													onInvalid={e => e.target.setCustomValidity('Please enter a valid card number')}
													onInput={e => e.target.setCustomValidity('')}
													placeholder="Last 4 digit"
													onChange={(event) => field.onChange(handleCardNumber(event))}
												/>}
											/>

											{/* expiry input filled  */}
											<Controller
												name="card_expry"
												type="text"
												id="card_expry"
												control={control}
												rules={{ required: (cardNumber.length === 4 && cardExpiry.length !== 4) ? true : false, maxLength: 5 }}
												render={({ field }) => <MaskedInput
													maskGenerator={expirymask}
													autoComplete="off"
													pattern="(?:0?[1-9]|1[0-2])/[0-9 ]{2}"
													maxLength='5'
													{...field}
													className="form-control"
													onInvalid={e => e.target.setCustomValidity('Please enter mm/yy format card expiry date')}
													onInput={e => e.target.setCustomValidity('')}
													placeholder="mm/yy"
													onChange={(event) => field.onChange(handleCardExpiry(event))}
												/>}
											/>
										</div>
										{(cardExpiry && cardNumber && cardExpiry.length < 4 && cardNumber.length < 4) ? <span className='srv-validation-message'>Please enter card info</span> :
											(cardExpiry && cardNumber.length < 4) ? <span className='srv-validation-message'>Please enter card last 4 digit</span> :
												(cardNumber && cardExpiry.length < 4) && <span className='srv-validation-message'>Please enter card expiry</span>
										}
									</div>
							<div className="col-sm-2 mt-3">
                                <div className='row'>
                                    <div className='col'>
                                        <button type="submit" name="submit" className="btn mt-2 w-100" style={{ backgroundColor: '#26A8E0', color: 'white' }} onClick={handleSubmit} > <div className='d-flex justify-content-center align-items-center'>
                                            <span>Search</span>
                                                <span className='ms-2'>
                                                    {loader ? <Circles
                                                        height="20"
                                                        width="20"
                                                        style={{ display: 'inline-block' }}
                                                        color="#ffffff"
                                                        ariaLabel="circles-loading"
                                                        visible={true}
                                                    /> : null}
                                                </span>
                                            </div>
                                        </button>
                                    </div>
                                    {ticketDetails?.ticket_number && <div className='col-6'>
                                        <button 
											type="button" 
											name="submit" 
											className="btn mt-2 w-100" 
											style={{ backgroundColor: '#26A8E0', color: 'white' }} 
											onClick={() => handleDownloadTicket(ticketDetails?.ticket_number)} > 
											<div className='d-flex justify-content-center align-items-center'>
												<span>Download <i className="fa fa-download"></i></span>
												<span className='ms-2'>
													{loaderDownload ? <Circles
														height="20"
														width="20"
														style={{ display: 'inline-block' }}
														color="#ffffff"
														ariaLabel="circles-loading"
														visible={true}
													/> : null}
												</span>
											</div>
                                        </button>
                                    </div>}
                                </div>
							</div>
						</div>
					</form>
                    {ticketDetails ? <Ticket ticketDetailsFromProps={ticketDetails}/> : error && <NoData message={error}/>} 
				</div>
			</div>
		</div>
		
	)
}


SearchTicket.propTypes = {
	dispatch: PropTypes.func,
	loader: PropTypes.bool,
	loaderSms: PropTypes.bool,
	loaderDownload: PropTypes.bool,
	notify: PropTypes.func,
}

SearchTicket.defaulProps = {
	dispatch: noop,
	loader: false,
	notify: noop,
}

function mapStateToProps({ userDetailsReducer }) {
	return {
		loader: userDetailsReducer?.loader,
		loaderSms: userDetailsReducer?.loaderSms,
		loaderDownload: userDetailsReducer?.loaderDownload,
	}
}
export default connect(mapStateToProps)(SearchTicket)

